import { redeemedAmountBeet } from '@metaplex-foundation/mpl-candy-guard';
import { mapSerializer, createSerializerFromBeet } from '../../../types/Serializer.mjs';
import { toBigNumber } from '../../../types/BigNumber.mjs';

/**
 * The redeemedAmount guard forbids minting when the
 * number of minted NFTs for the entire Candy Machine
 * reaches the configured maximum amount.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const redeemedAmountGuardManifest = {
  name: 'redeemedAmount',
  settingsBytes: 8,
  settingsSerializer: mapSerializer(createSerializerFromBeet(redeemedAmountBeet), settings => ({
    maximum: toBigNumber(settings.maximum)
  }), settings => settings)
};

export { redeemedAmountGuardManifest };
//# sourceMappingURL=redeemedAmount.mjs.map
